export default "__VITE_ASSET__7b994b9e__"